import { Button } from "@mui/material";
import StarterKit from "@tiptap/starter-kit";
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Table from "@tiptap/extension-table";
import Link from "@tiptap/extension-link";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";

import {
    MenuButtonBold,
    MenuButtonItalic,
    MenuControlsContainer,
    MenuDivider,
    MenuSelectHeading,
    RichTextEditor,
    MenuButtonBulletedList,
    MenuButtonOrderedList,
    MenuButtonUnderline,
    MenuButtonAlignLeft,
    MenuButtonAlignCenter,
    MenuButtonAlignRight,
    LinkBubbleMenuHandler,
    MenuButtonEditLink,
    LinkBubbleMenu,
    TableBubbleMenu,
    TableImproved
} from "mui-tiptap";

import { useRef, useState } from "react";

const RTE = ({onChange, idName, defaultValue}) => {
    const rteRef = useRef(null);
    const [value, setValue] = useState(defaultValue || '');

    return (
        <div>
            <RichTextEditor
                ref={rteRef}
                editorProps={{
                    style: {
                        border: '2px solid red',
                        borderRadius: '8px',
                        padding: '12px',
                        minHeight: '400px',
                    },
                }}
                extensions={[
                    StarterKit,
                    Underline,
                    TextAlign.configure({ types: ['heading', 'paragraph'] }),
                    Link,
                    TableRow,
                    TableCell,
                    TableHeader,
                    TableImproved,
                    LinkBubbleMenuHandler,
                ]}
                renderControls={() => (
                    <MenuControlsContainer>
                        <MenuSelectHeading />
                        <MenuDivider />
                        <MenuButtonBold />
                        <MenuButtonItalic />
                        <MenuButtonUnderline />
                        <MenuDivider />
                        <MenuButtonBulletedList />
                        <MenuButtonOrderedList />
                        <MenuDivider />
                        <MenuButtonAlignLeft />
                        <MenuButtonAlignCenter />
                        <MenuButtonAlignRight />
                        <MenuDivider />
                        <MenuButtonEditLink />
                    </MenuControlsContainer>
                )}
                id={idName}
                content={defaultValue}

                onUpdate={({editor}) => {
                    const html = editor.getHTML();
                    setValue(html);
                    if (onChange) {
                        onChange({target: {id: idName, value: html}});
                    }
                }}
            >
                {() => (
                    <>
                        <LinkBubbleMenu />
                        <TableBubbleMenu />
                    </>
                )}
            </RichTextEditor>
        </div >
    );
};

export default RTE;
